import type { Route } from '@angular/router';
import {
  adminGuard,
  authGuard,
  buyerGuard,
  paidGuard,
  supplierGuard,
} from '@indutrust/auth-data';

export const appRoutes: Route[] = [
  // Unauthenticated routes bypass
  // {
  //   path: 'toto',
  //   loadChildren: async () =>
  //     import('@indutrust/map-feature').then((m) => m.libMapRoutes),
  //   // import('@indutrust/company-feature').then((m) => m.libCompanyRoutes),
  // },

  // Docs Pages
  {
    path: 'docs',
    loadChildren: async () =>
      import('@indutrust/documentation-feature').then(
        (m) => m.libDocumentationRoutes
      ),
  },

  // Not authenticated routes
  {
    path: 'login',
    loadChildren: async () =>
      import('@indutrust/auth-feature').then((m) => m.authLoginRoutes),
  },
  {
    path: 'sign-up',
    loadChildren: async () =>
      import('@indutrust/auth-feature').then((m) => m.authRegisterRoutes),
  },
  {
    path: 'forgot-password',
    loadChildren: async () =>
      import('@indutrust/auth-feature').then((m) => m.authForgotPasswordRoutes),
  },
  {
    path: 'reset-password',
    loadChildren: async () =>
      import('@indutrust/auth-feature').then((m) => m.authResetPasswordRoutes),
  },

  // Authenticated routes
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: async () =>
          import('@indutrust/home-feature').then((m) => m.libHomeRoutes),
      },
      {
        path: 'backoffice',
        loadChildren: async () =>
          import('@indutrust/backoffice-feature').then(
            (m) => m.libBackofficeRoutes
          ),
        canActivate: [adminGuard],
      },
      {
        path: 'company',
        loadChildren: async () =>
          import('@indutrust/company-feature').then((m) => m.libCompanyRoutes),
      },
      {
        path: 'contact-us',
        loadChildren: async () =>
          import('@indutrust/contact-us-feature').then(
            (m) => m.libContactUsRoutes
          ),
      },
      {
        path: 'dashboard',
        loadChildren: async () =>
          import('@indutrust/dashboard-feature').then(
            (m) => m.libDashboardRoutes
          ),
      },
      {
        path: 'docs',
        loadChildren: async () =>
          import('@indutrust/documentation-feature').then(
            (m) => m.libDocumentationRoutes
          ),
      },
      {
        path: 'factories',
        loadChildren: async () =>
          import('@indutrust/factory-feature').then(
            (m) => m.libFactoriesListRoutes
          ),
      },
      {
        path: 'factory',
        loadChildren: async () =>
          import('@indutrust/factory-feature').then((m) => m.libFactoryRoutes),
      },
      {
        path: 'virtual-tour',
        canActivate: [supplierGuard],
        loadComponent: async () =>
          import('@indutrust/factory-feature').then(
            (m) => m.VirtualTourPageComponent
          ),
      },
      {
        path: 'notifications',
        loadChildren: async () =>
          import('@indutrust/notification-feature').then(
            (m) => m.libNotificationRoutes
          ),
      },
      {
        path: 'search',
        loadChildren: async () =>
          import('@indutrust/search-feature').then((m) => m.libSearchRoutes),
        canActivate: [buyerGuard, paidGuard],
        data: {
          paidWall: { family: 'discovery', featureId: 'search' },
        },
      },
      {
        path: 'help-center',
        loadChildren: async () =>
          import('@indutrust/help-center-feature').then(
            (m) => m.libHelpCenterRoutes
          ),
      },
      {
        path: 'industrial-area',
        loadChildren: async () =>
          import('@indutrust/industrial-area-feature').then(
            (m) => m.libIndustrialAreaRoutes
          ),
      },
      {
        path: 'map',
        loadChildren: async () =>
          import('@indutrust/map-feature').then((m) => m.libMapRoutes),
      },
      {
        path: 'project',
        redirectTo: 'projects',
        pathMatch: 'prefix',
      },
      {
        path: 'projects',
        loadChildren: async () =>
          import('@indutrust/project-feature').then((m) => m.libProjectRoutes),
        canActivate: [buyerGuard, paidGuard],
        data: {
          paidWall: { family: 'workflow', featureId: 'projects' },
        },
      },
      {
        path: 'reporting',
        loadChildren: async () =>
          import('@indutrust/dashboard-feature').then(
            (m) => m.libReportingRoutes
          ),
      },
    ],
    canActivate: [authGuard],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
